import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#7b1fa2',     // Rich purple - auspicious / celebratory
      light: '#ae52d4',
      dark: '#4a0072',
    },
    secondary: {
      main: '#f9a825',     // Golden yellow - traditional Indian wedding palette
      light: '#ffd95a',
      dark: '#c17900',
    },
    background: {
      default: '#fdf6ff',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: "'Poppins', 'Roboto', sans-serif",
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 600 },
    h5: { fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
});

export default theme;
